import axios from 'axios';
const user = (sessionStorage.getItem('sess_id'));

class UserService {
  getBalance(ticker) {
    return axios.get('/getbalance', { params: { "ticker": ticker,"sess_id" : user} });
  }

  getaddresses(ticker) {
    return axios.get('/getaddresses', {  params: { "ticker": ticker,"sess_id" : user } });

  }

  gettransaction(ticker) {
    return axios.get('/gettransaction', { params: { "ticker": ticker ,"sess_id" : user }});
  }

  getCoindetail() {
    
    return axios.get('/getCoindetail',{ params: {"sess_id" : user }});
  }

  getCoindetailbyTicker(ticker) {
    
    return axios.get('/getCoindetailbyTicker',{ params: {"sess_id" : user,"ticker": ticker  }});
  }



  getCoin() {
    return axios.get('/getCoin', { params:{ "sess_id" : user}});
  }

  createtx(ticker, ToAddress, Amount) {
    return axios.get('/createtx', {  params: { "ticker": ticker, "ToAddress": ToAddress, "Amount": Amount,"sess_id" : user } });
  }

  getmnemonic() {
    return axios.get('/getmnemonic', { params:{"sess_id" : user }});
  }

  CreateWallet() {
    return axios.get('/CreateWallet', { params:{ "sess_id" : user}});
  }

  
 

  Witdrawal(ticker) {
    return axios.get('/Witdrawal', { params:{ "sess_id" : user, "ticker": ticker }});
  }

  combinetx(ticker) {
    return axios.get('/combinetx', {  params: {"sess_id" : user, "ticker": ticker } });
  }

  send(ticker, txs) {
    console.log(user);
    return axios
      .post("/send", { params: { "ticker": ticker, "txs": txs,"sess_id" : user } })
      .then((response) => {
        return response.data;
      });
  }  

  getpubkey(ticker) {
    return axios.get('/getpubkey', { params:{"sess_id" : user, "ticker": ticker }});
  }
}
export default new UserService();
